module.exports = __webpack_public_path__ + "static/media/useful5.4eff98b0.png";